import config from "@/config"
import { msTimestampFormat } from "@/utils"
import store from "@/store"

export const getColumns = [
    {
        title: "产品线",
        dataIndex: "software_id",
        customRender: (text: any) =>
            (store.state.common.software_list.find((item: any) => item.software_id === text) as any)
                ?.software_name || "--",
        width: 80
    },
    {
        title: "CDN域名",
        dataIndex: "cdn_domain",
        width: 150
    },
    {
        title: "公司主体",
        dataIndex: "corporate",
        customRender: (text: any) =>
            store.state.common.corporation.find(item => item.value === text)?.label || "--",
        span: 1,
        width: 200
    },
    {
        title: "事业部",
        dataIndex: "dept",
        customRender: (text: any) =>
            store.state.common.top_dept.find(item => item.value == text)?.label || "--",
        width: 200
    },
    {
        title: "创建人",
        dataIndex: "create_user",
        width: 120,
        renderProps: {
            showPopover: true,
            platform_id: config.api.PID
        },
        renderType: "user"
    },
    {
        title: "创建时间",
        dataIndex: "create_time",
        width: 150,
        customRender: (text: number) => {
            return text ? msTimestampFormat(text, "YYYY-MM-DD HH:mm:ss") : "-"
        }
    }
]
